"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _intlDesignUi = require("@tencent/intl-design-ui");
var _classnames = _interopRequireDefault(require("classnames"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
const range = (start, end) => [...Array(end - start + 1).keys()].map(item => start + item + '');
const TimeMultipleChoiceInput = ({
  name,
  required,
  onChange,
  onBlur,
  onFocus,
  data,
  langObj
}) => {
  const _langObj$year = langObj.year,
    year = _langObj$year === void 0 ? 'year' : _langObj$year,
    _langObj$month = langObj.month,
    month = _langObj$month === void 0 ? 'month' : _langObj$month,
    _langObj$day = langObj.day,
    day = _langObj$day === void 0 ? 'day' : _langObj$day;
  const _useState = (0, _react.useState)('--'),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    inputValue = _useState2[0],
    setInputValue = _useState2[1];
  const currYear = new Date().getFullYear();
  const OPTIONS = [{
    key: 'year',
    placeholder: year,
    value: range(2010, currYear)
  }, {
    key: 'month',
    placeholder: month,
    value: range(1, 12)
  }, {
    key: 'day',
    placeholder: day,
    value: []
  }];
  const _useState3 = (0, _react.useState)(OPTIONS),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    timeOptions = _useState4[0],
    setTimeOptions = _useState4[1];
  const _useState5 = (0, _react.useState)(''),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    editYearMonth = _useState6[0],
    setEditYearMonth = _useState6[1];
  const allValueChange = (key, val) => {
    const newVal = inputValue.replace(/(\d+)?-(\d+)?-(\d+)?/g, ($, $1, $2) => {
      switch (key) {
        case 'year':
          setEditYearMonth('year');
          return `${val}-${$2 || ''}-`;
        case 'month':
          setEditYearMonth('month');
          return `${$1 || ''}-${val}-`;
        case 'day':
          setEditYearMonth('day');
          return `${$1 || ''}-${$2 || ''}-${val}`;
      }
    });
    newVal.replace(/(\d+)?-(\d+)?-(\d+)?/g, ($, $1, $2) => {
      switch ($2) {
        case '1':
        case '3':
        case '5':
        case '7':
        case '8':
        case '10':
        case '12':
          OPTIONS[2].value = range(1, 31);
          break;
        case '4':
        case '6':
        case '9':
        case '11':
          OPTIONS[2].value = range(1, 30);
          break;
        case '2':
          OPTIONS[2].value = $1 % 4 === 0 && !($1 % 100 === 0) || $1 % 400 === 0 ? range(1, 29) : range(1, 28);
          break;
        default:
          break;
      }
      setTimeOptions([...OPTIONS]);
    });
    setInputValue(newVal);
    onChange(newVal);
  };
  const renderTimeOptions = (type, index) => {
    const selectRef = (0, _react.useRef)(null);
    const _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      isOpen = _useState8[0],
      setIsOpen = _useState8[1];
    const _useState9 = (0, _react.useState)(''),
      _useState0 = (0, _slicedToArray2.default)(_useState9, 2),
      value = _useState0[0],
      setValue = _useState0[1];
    const valueChange = () => {
      setValue('');
    };
    const valueFocus = () => {
      onFocus();
    };
    const valueBlur = () => {
      onBlur();
    };
    const optionClick = item => {
      setIsOpen(false);
      setValue(item);
      allValueChange(type.key, item);
    };
    const closeDownList = event => {
      if (!selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    (0, _react.useEffect)(() => {
      document.addEventListener('click', closeDownList, false);
      return () => {
        document.removeEventListener('click', closeDownList, false);
      };
    }, []);
    (0, _react.useEffect)(() => {
      if ((editYearMonth === 'year' || editYearMonth === 'month') && type.key === 'day') {
        setValue('');
        allValueChange(type.key, '');
      }
    }, [editYearMonth]);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "i-form-combo-mod",
      key: `time_input_${index}`,
      ref: selectRef
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('rno-select rno-select-placeholder rno-select-full-width ', {
        'rno-select-open': isOpen
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "region_box",
      onClick: () => setIsOpen(true)
    }, /*#__PURE__*/_react.default.createElement("input", {
      placeholder: type.placeholder,
      className: "rno-input ",
      value: value,
      onChange: valueChange,
      onBlur: valueBlur,
      onFocus: valueFocus
    }), /*#__PURE__*/_react.default.createElement(_intlDesignUi.Icon, {
      name: "arrow-down",
      size: 24,
      color: 'rgba(0, 0, 0, 0.3)',
      className: "arrow-down"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "rno-dropdown rno-select-dropdown rno-dropdown-bottom"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "rno-dropdown-menu"
    }, type.value.map((item, index) => /*#__PURE__*/_react.default.createElement("li", {
      className: "rno-dropdown-menu-item",
      onClick: () => optionClick(item),
      key: `time_dropdown_${type.key}_${index}`
    }, /*#__PURE__*/_react.default.createElement("span", null, item)))))));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'intl-form-item': true,
      'rno-form-item': true,
      'rno-form-item-multipleChoice': true,
      'rno-form-required': required,
      'rno-form-status-error': data.isError
    })
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: "form-component-label-s"
  }, name, required && /*#__PURE__*/_react.default.createElement("span", null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "rno-form-controls"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "rno-form-item-time"
  }, timeOptions.map(renderTimeOptions)), /*#__PURE__*/_react.default.createElement("div", {
    className: "rno-form-message"
  }, data.errMsg || '')));
};
var _default = exports.default = TimeMultipleChoiceInput;